import { useEffect, useState } from "react";

export function useCapsLock() {
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const updateFromEvent = (e) => {
    try {
      const hasGetter = typeof e.getModifierState === "function";
      const reported = hasGetter && e.getModifierState("CapsLock");

      let inferred = false;
      const key = e.key;
      const isLetter = key && key.length === 1 && key.toLowerCase() !== key.toUpperCase();
      if (isLetter) {
        const isUpper = key === key.toUpperCase();
        const isShift = e.shiftKey === true;
        inferred = (!isShift && isUpper) || (isShift && !isUpper);
      }

      const isCapsToggleKey = e.code === "CapsLock" || e.key === "CapsLock";
      setIsCapsLockOn((prev) => (isCapsToggleKey && !hasGetter ? !prev : (reported || inferred)));
    } catch (_) {
      // ignore
    }
  };

  useEffect(() => {
    const onKeyDown = (e) => updateFromEvent(e);
    const onKeyUp = (e) => updateFromEvent(e);
    window.addEventListener("keydown", onKeyDown, true);
    window.addEventListener("keyup", onKeyUp, true);
    return () => {
      window.removeEventListener("keydown", onKeyDown, true);
      window.removeEventListener("keyup", onKeyUp, true);
    };
  }, []);

  return {
    isCapsLockOn: isActive && isCapsLockOn,
    bind: {
      onFocus: () => setIsActive(true),
      onBlur: () => setIsActive(false),
    },
    updateFromEvent,
    setActive: setIsActive,
  };
}


